
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import * as showdown from "showdown";
    const glossaryJson = require('./glossary.json')
   

    @Component
    export default class Tooltip extends Vue {

        @Prop({required: true})
        title!: string;

        @Prop({required: true})
        index!: string;

        @Prop({required: false, default:'right'})
        placement!: string;

        @Prop({required: false, default:'sm'})
        size!: string;
        
        markdownConverter = new showdown.Converter({
            noHeaderId: true
        });

        description = ''

        mounted()
        {
            const content = glossaryJson[this.title.toLowerCase()]
            this.description = this.formatHtml(content)
        }

        public formatHtml(content) {
            if (content !== undefined) {
                content = this.markdownConverter.makeHtml(content);
                content = content.replace(/<a ([^>]+)/g, function (a) {
                return a + 'style="color:orange;" target="_blank"';
                });
            }
            return content;
        }

    }
